import React from 'react';
import { StyledSlashHeader, PlaySlash, HeaderText } from './SlashHeader.styles';
import PropTypes from 'prop-types';

const SlashHeader = ({ text, type, dataRt }) => (
    <StyledSlashHeader as={type ? type : 'h1'} data-rt={dataRt}>
        <PlaySlash aria-hidden={true} />
        <HeaderText data-rt="slash-header-text">{text}</HeaderText>
    </StyledSlashHeader>
);

SlashHeader.propTypes = {
    text: PropTypes.node.isRequired,
    type: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5']).isRequired,
};

export default SlashHeader;
